import { useTranslation } from 'react-i18next';
// TODO: Implement logic to make editable profile info by user role
const useProfileInfo = ({ setAttributeChanges }) => {
  const { t } = useTranslation();
  const settingAttribute = (attribute) => (
    (newValue) => setAttributeChanges((prev) => {
      if (attribute === 'phoneNumber') return ({ ...prev, [attribute]: `+${t('Phone prefix')}${newValue}` });
      return ({ ...prev, [attribute]: newValue });
    }));
  return [
    {
      title: 'Empresa',
      getAttribute: (user) => user.selectedCompany?.name,
      attributeName: 'companyName',
      category: 'company',
    },
    {
      title: 'Rut empresa',
      getAttribute: (user) => user.selectedCompany?.masterEntity.displayNationalIdentifier,
      attributeName: 'companyRut',
      category: 'company',
    },
    {
      title: 'Nombre',
      getAttribute: (user) => user.firstName,
      attributeName: 'firstName',
      onChangeInput: settingAttribute('firstName'),
      category: 'user',
    },
    {
      title: 'Apellido',
      getAttribute: (user) => user.lastName,
      attributeName: 'lastName',
      onChangeInput: settingAttribute('lastName'),
      category: 'user',
    },
    {
      title: 'Rol',
      getAttribute: () => 'Apoderado',
      attributeName: 'role',
      category: 'user',
    },
    {
      title: 'Teléfono de contacto',
      getAttribute: (user) => (user.phoneNumber ? user.phoneNumber.slice(3) : ''),
      attributeName: 'phoneNumber',
      onChangeInput: settingAttribute('phoneNumber'),
      type: 'phone',
      category: 'user',
    },
    {
      title: 'Email de contacto',
      getAttribute: (user) => user.mailProvided,
      attributeName: 'mailProvided',
      onChangeInput: settingAttribute('mailProvided'),
      type: 'email',
      category: 'company',
    },
  ];
};

export default useProfileInfo;
